// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payments-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1rem;
  margin-bottom: 2rem;
}
@media (max-width: 768px) {
  .payments-container {
    margin-bottom: 1rem;
  }
}

.payments-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.payments-title .paylixecommerce-label {
  margin-bottom: 0;
}
.payments-title .switcher {
  width: 1.8rem;
  min-width: 1.8rem;
  height: 1rem;
  margin: 0 0 0 0.5rem;
}
.payments-title .switcher-container {
  width: auto;
  white-space: nowrap;
  margin-left: -1rem;
}
.payments-title .switcher input:checked ~ .switcher-slider::before {
  transform: translateX(13px);
}
.payments-title .switcher .switcher-slider:before {
  width: 13px;
  height: 13px;
  top: 1.5px;
  left: 1px;
  border-color: var(--black4);
}
.payments-title .switcher .switcher-slider {
  background-color: var(--black4);
}
.payments-title .switcher-label {
  width: calc(100% - 2.35rem);
}
.payments-title .switcher-label .paylixecommerce-label span {
  cursor: pointer;
  color: var(--purple6);
}

.dark .payment-checkbox {
  background: var(--black1);
}

.payment-checkbox {
  width: calc(25% - 0.75rem);
  height: 44px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.75rem;
  margin-right: 0;
  position: relative;
  min-height: 1.5rem;
  font-weight: 500;
  background: var(--white);
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  border-radius: 0.5rem;
}
@media (max-width: 1124px) {
  .payment-checkbox {
    width: calc(33.33% - 0.666rem);
  }
}
.payment-checkbox.active {
  border-color: var(--purple6);
  border-width: 2px;
}
.payment-checkbox > input {
  box-sizing: border-box;
  padding: 0;
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.payment-checkbox > input:not(:disabled):active ~ span::before {
  color: #fff;
  background-color: #e3dcfb;
  border-color: #e3dcfb;
}
.payment-checkbox > input:focus ~ span::before {
  border-color: var(--purple3);
  box-shadow: 0 0 0 0.2rem var(--purple6);
}
.payment-checkbox > input:checked ~ span::before {
  color: #fff;
  border-color: var(--purple6);
  background-color: var(--purple6);
}
.payment-checkbox > input:checked ~ span::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}
.payment-checkbox > span {
  position: relative;
  margin-bottom: 0;
  cursor: pointer;
}
.payment-checkbox > span:before {
  position: absolute;
  cursor: pointer;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #e8e8e9 solid 2px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 2px;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.payment-checkbox > span:after {
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  position: absolute;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}
.payment-checkbox.disabled {
  background: var(--black2);
}
@media (max-width: 420px) {
  .payment-checkbox {
    width: 100%;
    margin-right: 0;
  }
}
.payment-checkbox > span {
  display: flex;
  align-items: center;
  color: var(--black9);
  font-size: 14px;
  cursor: pointer;
  margin-left: 25px;
  width: 100%;
  justify-content: space-between;
}
.payment-checkbox > span > span {
  font-size: 12px;
  color: var(--black9);
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  line-height: 1.2;
}
.payment-checkbox > span i, .payment-checkbox > span img {
  margin-left: 0.25rem;
  font-size: 20px;
}
.payment-checkbox > span label::before, .payment-checkbox > span label::after {
  top: 0.2em;
}

@media (max-width: 768px) {
  .payment-checkbox {
    width: 100%;
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/payment/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EAPF;IAQI,mBAAA;EAEF;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;AADJ;AAGI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;AADN;AAII;EACE,2BAAA;AAFN;AAKI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AAHN;AAMI;EACE,+BAAA;AAJN;AASE;EACE,2BAAA;AAPJ;AAUM;EACE,eAAA;EACA,qBAAA;AARR;;AAiBE;EACE,yBAAA;AAdJ;;AAkBA;EACE,0BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,+BAAA;EACA,4CAAA;EACA,qBAAA;AAfF;AAiBE;EAhBF;IAiBI,8BAAA;EAdF;AACF;AAgBE;EACE,4BAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAfJ;AAiBI;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAfN;AAkBI;EACE,4BAAA;EACA,uCAAA;AAhBN;AAmBI;EACE,WAAA;EACA,4BAAA;EACA,gCAAA;AAjBN;AAoBI;EACE,oEAAA;AAlBN;AAsBE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AApBJ;AAsBI;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,4GAAA;AApBN;AAuBI;EACE,QAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;AArBN;AA4BE;EACE,yBAAA;AA1BJ;AA6BE;EAjGF;IAkGI,WAAA;IACA,eAAA;EA1BF;AACF;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;AA1BJ;AA4BI;EACE,eAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA1BN;AA6BI;EACE,oBAAA;EACA,eAAA;AA3BN;AAgCE;EACE,UAAA;AA9BJ;;AAkCA;EAKE;IACE,WAAA;IACA,mBAAA;EAnCF;AACF","sourcesContent":[".payments-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin-bottom: 2rem;\n\n  @media (max-width: 768px) {\n    margin-bottom: 1rem;\n  }\n\n}\n\n\n.payments-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n\n  .paylixecommerce-label {\n    margin-bottom: 0;\n  }\n\n  .switcher {\n    width: 1.8rem;\n    min-width: 1.8rem;\n    height: 1rem;\n    margin: 0 0 0 .5rem;\n\n    &-container {\n      width: auto;\n      white-space: nowrap;\n      margin-left: -1rem;\n    }\n\n    input:checked ~ .switcher-slider::before {\n      transform: translateX(13px);\n    }\n\n    .switcher-slider:before {\n      width: 13px;\n      height: 13px;\n      top: 1.5px;\n      left: 1px;\n      border-color: var(--black4);\n    }\n\n    .switcher-slider {\n      background-color: var(--black4);\n    }\n\n  }\n\n  .switcher-label {\n    width: calc(100% - 2.35rem);\n\n    .paylixecommerce-label {\n      span {\n        cursor: pointer;\n        color: var(--purple6);\n      }\n    }\n  }\n\n}\n\n\n.dark {\n  .payment-checkbox {\n    background: var(--black1);\n  }\n}\n\n.payment-checkbox {\n  width: calc(25% - .75rem);\n  height: 44px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: .75rem;\n  margin-right: 0;\n  position: relative;\n  min-height: 1.5rem;\n  font-weight: 500;\n  background: var(--white);\n  border: 1px solid var(--black2);\n  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n  border-radius: .5rem;\n\n  @media (max-width: 1124px) {\n    width: calc(33.33% - .666rem);\n  }\n\n  &.active {\n    border-color: var(--purple6);\n    border-width: 2px;\n  }\n\n  & > input {\n    box-sizing: border-box;\n    padding: 0;\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n\n    &:not(:disabled):active ~ span::before {\n      color: #fff;\n      background-color: #e3dcfb;\n      border-color: #e3dcfb;\n    }\n\n    &:focus ~ span::before {\n      border-color: var(--purple3);\n      box-shadow: 0 0 0 0.2rem var(--purple6);\n    }\n\n    &:checked ~ span::before {\n      color: #fff;\n      border-color: var(--purple6);\n      background-color: var(--purple6);\n    }\n\n    &:checked ~ span::after {\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\") !important\n    }\n  }\n\n  & > span {\n    position: relative;\n    margin-bottom: 0;\n    cursor: pointer;\n\n    &:before {\n      position: absolute;\n      cursor: pointer;\n      left: -1.5rem;\n      display: block;\n      width: 1rem;\n      height: 1rem;\n      pointer-events: none;\n      content: \"\";\n      background-color: #fff;\n      border: #e8e8e9 solid 2px;\n      top: 50%;\n      transform: translateY(-50%);\n      border-radius: 2px;\n      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    }\n\n    &:after {\n      top: 50%;\n      cursor: pointer;\n      transform: translateY(-50%);\n      position: absolute;\n      left: -1.5rem;\n      display: block;\n      width: 1rem;\n      height: 1rem;\n      content: \"\";\n      background: no-repeat 50%/50% 50%;\n    }\n  }\n\n\n\n\n  &.disabled {\n    background: var(--black2);\n  }\n\n  @media (max-width: 420px) {\n    width: 100%;\n    margin-right: 0;\n  }\n\n  & > span {\n    display: flex;\n    align-items: center;\n    color: var(--black9);\n    font-size: 14px;\n    cursor: pointer;\n    margin-left: 25px;\n    width: 100%;\n    justify-content: space-between;\n\n    & > span {\n      font-size: 12px;\n      color: var(--black9);\n      width: 100%;\n      justify-content: space-between;\n      display: flex;\n      align-items: center;\n      line-height: 1.2;\n    }\n\n    i, img {\n      margin-left: .25rem;\n      font-size: 20px;\n      //color: initial !important;\n    }\n  }\n\n  & > span label::before, & > span label::after {\n    top: 0.20em;\n  }\n}\n\n@media (max-width: 768px) {\n  .payments-container {\n\n  }\n\n  .payment-checkbox {\n    width: 100%;\n    margin-bottom: 1rem;\n\n    &.active {\n\n    }\n\n    & > input {\n\n      &:not(:disabled):active ~ span::before {\n\n      }\n\n      &:focus ~ span::before {\n\n      }\n\n      &:checked ~ span::before {\n\n      }\n\n      &:checked ~ span::after {\n\n      }\n    }\n\n    & > span {\n\n      &:before {\n\n      }\n\n      &:after {\n\n      }\n    }\n\n\n    &.disabled {\n\n    }\n\n    & > span {\n\n      & > span {\n\n      }\n\n      i, img {\n\n      }\n    }\n\n    & > span label::before, & > span label::after {\n\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
